export default "__VITE_ASSET__CiL70oAj__"